import { ROUTE_PATH_ADMIN } from '../../configRoutes';

export const ROUTE_PATH_ALFRED_ACADEMY = ROUTE_PATH_ADMIN + '/academy';
